import React from 'react';
import {connect} from 'react-redux';
import strings from '../../utils/strings';
// import './styles.scss';

import previewVideoNo from './assets/4006868833093d06696ae39c73ba2ffb.mp4';
import previewVideoNn from './assets/4006868833093d06696ae39c73ba2ffb.mp4';

import previewVideoSe from './assets/4006868833093d06696ae39c73ba2ffb.mp4';
import previewVideoDe from './assets/DE_Orddiktat.mp4';

import {VARIATION} from '../../constants';

import AudioPlayer from '../../components/AudioPlayer';

class Intro extends React.Component {
	constructor() {
		super();
		this.state = {
			hasPlayedIntro:false
		};
		const variation = VARIATION;
		const language = strings.getLanguage();
		const previewVideoObj = {
			no: previewVideoNo,
			nn: previewVideoNn,
			se: previewVideoSe,
			de: previewVideoDe,
		};

		const audio = require(`../../assets/sounds/${variation}/${language}/1 0 Orddiktat Intro.mp3`);
		this.audio = audio;
		this.video = previewVideoObj[language];
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div className="lit-intro">
				<p
					style={{
						marginBottom: 0,
					}}
				>
					<AudioPlayer
						autoplay
						inline
						onPause={() => {
							videoRef.play();
						}}
						onComplete={()=>{
							this.setState({
								hasPlayedIntro:true
							});
						}}
						src={this.audio}
					/>
					{strings.orddiktatIntro}
				</p>
				<div className="text-center">
					<div className="lit-preview">
						<p className="lit-preview__label">
							{strings.testLooksLikeThis}
						</p>
						<video
							className="lit-preview__video"
							loop
							ref={(ref) => {
								videoRef = ref;
							}}
							src={this.video}
						/>
					</div>
				</div>
				<div>
					<p className="showme">{`"${strings.clickonplaybutton}"`}</p>
					</div>
					
				{this.state.hasPlayedIntro && (
					<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
